export var LoyaltyCardsType;
(function (LoyaltyCardsType) {
    LoyaltyCardsType["IndividualCard"] = "IndividualCard";
    LoyaltyCardsType["CorporateCard"] = "CorporateCard";
})(LoyaltyCardsType || (LoyaltyCardsType = {}));
